// Translations for the Cases (legal/disciplinary cases) page.
const casesDict = [
  { en: "Kesi imesasishwa!", sw: "Kesi imesasishwa!" },
  { en: "Kesi imetumwa!", sw: "Kesi imetumwa!" },
  { en: "Hitilafu imetokea", sw: "Hitilafu imetokea" },
  { en: "Una uhakika unataka kufuta kesi hii?", sw: "Una uhakika unataka kufuta kesi hii?" },
  { en: "Kesi imefutwa", sw: "Kesi imefutwa" },
  { en: "Migogoro na Kesi za Kazi", sw: "Migogoro na Kesi za Kazi" },
  { en: "Ripoti na fuatilia kesi za migogoro ya kikazi", sw: "Ripoti na fuatilia kesi za migogoro ya kikazi" },
  { en: "Ripoti Kesi Mpya", sw: "Ripoti Kesi Mpya" },
  { en: "All Statuses", sw: "Hali Zote" },
  { en: "Open", sw: "Wazi" },
  { en: "Investigating", sw: "Inachunguzwa" },
  { en: "Mediation", sw: "Upatanishi" },
  { en: "Legal Action", sw: "Hatua za Kisheria" },
  { en: "Resolved", sw: "Imetatuliwa" },
  { en: "Closed", sw: "Imefungwa" },
  { en: "All Types", sw: "Aina Zote" },
  { en: "Disciplinary", sw: "Nidhamu" },
  { en: "Salary", sw: "Mshahara" },
  { en: "Transfer", sw: "Uhamisho" },
  { en: "Harassment", sw: "Unyanyasaji" },
  { en: "Unfair Dismissal", sw: "Kufukuzwa Kazi" },
  { en: "Contract Violation", sw: "Ukiukaji wa Mkataba" },
  { en: "Other", sw: "Nyingine" },
  { en: "Type:", sw: "Aina:" },
  { en: "Member:", sw: "Mwanachama:" },
  { en: "Date:", sw: "Tarehe:" },
  { en: "Assigned to:", sw: "Imekabidhiwa:" },
  { en: "Edit case", sw: "Hariri kesi" },
  { en: "Edit", sw: "Hariri" },
  { en: "Delete case", sw: "Futa kesi" },
  { en: "Delete", sw: "Futa" },
  { en: "No cases found", sw: "Hakuna kesi zilizopatikana" },
  { en: "If you have a workplace dispute, please report it here.", sw: "Kama una mgogoro wa kikazi, tafadhali ripoti hapa." },
  { en: "Edit Case", sw: "Hariri Kesi" },
  { en: "Case Type", sw: "Aina ya Kesi" },
  { en: "Case Title", sw: "Kichwa cha Kesi" },
  { en: "Description", sw: "Maelezo" },
  { en: "Priority", sw: "Umuhimu" },
  { en: "Low", sw: "Chini" },
  { en: "Medium", sw: "Kati" },
  { en: "High", sw: "Juu" },
  { en: "Urgent", sw: "Haraka" },
  { en: "Employer Details (Optional)", sw: "Maelezo ya Mwajiri (Hiari)" },
  { en: "Company name, manager name, etc.", sw: "Jina la kampuni, jina la meneja, nk" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Update", sw: "Sasisha" },
  { en: "Submit", sw: "Wasilisha" },
];

export default casesDict;
